interface IGradientBorderProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  childrenClassName?: string;
}

const GradientBorder: React.FC<IGradientBorderProps> = ({
  children,
  className,
  childrenClassName,
  ...rest
}) => {
  return (
    <div className={`p-[1px] ${className}`} {...rest}>
      <div className={`radius-inherit h-full w-full ${childrenClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default GradientBorder;
